import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { ModalContent } from '@creditornot/cbt-modal';
import React from 'react';
import { Form } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Brand } from 'apis/enterprise/types';
import { WoltModal } from 'common/components';
import useGetBrandVenues from 'modules/brand/hooks/useGetBrandVenues';

import { AddVenuesToVenueGroup } from './AddVenuesToVenueGroup';
import { Loading, Error } from './styles';

export type FormValues = {
  venueIds: string[];
};

type Props = {
  isOpen: boolean;
  brand: Brand;
  onSubmit: (values: FormValues) => void;
  onClose: () => void;
  initialVenueIds?: string[];
};

const Root = styled(WoltModal)`
  width: 700px;
  background: ${cbSemanticCssVars.surfaceMain};
  border-radius: 8px;
`;

export const AddVenuesToVenueGroupModal = ({ brand, onSubmit, isOpen, onClose, initialVenueIds = [] }: Props) => {
  const { venues, isLoading, error } = useGetBrandVenues({ brand });

  return (
    <Root isOpen={isOpen} onRequestClose={onClose}>
      <Form<FormValues>
        onSubmit={onSubmit}
        initialValues={{ venueIds: initialVenueIds }}
        render={({ handleSubmit }) => {
          if (isLoading) {
            return (
              <ModalContent>
                <Loading />
              </ModalContent>
            );
          }

          if (error) {
            return (
              <ModalContent>
                <Error>
                  <FormattedMessage id="venue-groups.error" />
                </Error>
              </ModalContent>
            );
          }

          return (
            <form onSubmit={handleSubmit}>
              <AddVenuesToVenueGroup disableSaveButtonByDefault venues={venues} onClose={onClose} />
            </form>
          );
        }}
      />
    </Root>
  );
};
